/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable guard-for-in */
/* eslint-disable arrow-body-style */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Queue } from 'queue-typescript';
import {BehaviorSubject, Observable} from 'rxjs';
// import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import {AnalyticsEvent} from './analytics-event';
import * as moment from 'moment';
import {HttpClient} from '@angular/common/http';
import {API_ENDPOINT} from '../../../../environments/environment';
import {ErrorService} from '../errors/error.service';
import {SimpleEventDispatcher} from 'ste-simple-events';
import {StorageService} from '../storage.service';
import { ConfigService } from '../config/config.service';
import { Platform } from '@ionic/angular';
// import { QUEUE_STORAGE } from '../../timesheet-queue.service';
import { LogsService } from '../utils/logs.service';
import { AuthenticationService } from '../../authentication.service';
import { ResponseType } from '../errors/custom-error';
import { EnvService } from '../config/env.service';

export const ANALYTICS_STORAGE = 'analytics-storage';
export const TRACK_API_PATH = '/track';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {


    private _ready$: Observable<boolean>;
    private queue = new Queue<AnalyticsEvent>();
    private _running = false;
    private _ready = new BehaviorSubject<boolean>(false); // true is your initial value
    private _internal_props = {};
    private _onTrackEventAdded = new SimpleEventDispatcher<AnalyticsEvent>();

    constructor(
        private storage: StorageService,
        private http: HttpClient,
        private envService: EnvService,
        public errorService: ErrorService,
        private plt: Platform,
        private logs: LogsService,
        private authenticationService: AuthenticationService,
    ) {
        this._ready$ = this._ready.asObservable();

        this.plt.ready().then(() => {
            this.init();
        });
    }

    async init() {
        this.getPending().then(pending => {
            for (const item of pending) {
                this.queue.enqueue(item);
            }
            this._ready.next(true);
        });
        this.envService.getDeviceInfo().then(info => Object.assign(this._internal_props, info));
        this._onTrackEventAdded.asEvent().subscribe( ev => {
            console.log('[ANALYTICS] _onTrackEventAdded');
        });
    }

    public async getPending(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.storage.get(ANALYTICS_STORAGE).then(data => {
                if (data !== null) {
                    const items = [];
                    for (const item in data) {
                        const request = new AnalyticsEvent(data[item]);
                        items.push(request);
                    }
                    resolve(items);
                } else {
                    resolve([]);
                }
            });
        });
    }

    public async onReady(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this._ready.getValue() === true) {
                resolve(true);
            } else {
                this._ready$
                    .subscribe(fixed => {
                        if (fixed === true) {
                            resolve(true);
                        }
                    });
            }
        });
    }

    async track(name: string, properties: any = {}) {
        return new Promise((resolve, reject) => {
            const event = new AnalyticsEvent();
            event.date = moment();
            event.name = name;
            event.group = 'kiosk';
            event.properties = Object.assign(this._internal_props, properties);
            this.queue.enqueue(event);
            this.runPending();
            this._onTrackEventAdded.dispatch(event);
            resolve(true);
        });
    }

    async runPending(force: boolean = false) {
        // Check if already running
        if (this._running && !force) { return; }
        this._running = true;
        // this.backgroundMode.enable();
        this.onReady().then(ready => {
            if (this.queue.length > 0) {
                const next = this.queue.front;
                this.run(next);
            } else {
                this.setNotRunning();
            }
        });
    }

    public empty() {
        this.queue = new Queue<AnalyticsEvent>();
        this.persistQueue();
    }

    async run(event: AnalyticsEvent) {
        this.sendEvent(event).then(res => {
            this.queue.dequeue();
            this.persistQueue();
            this.runPending(true);
        }, e => {
            if (e.type === ResponseType.ServerError || e.type === ResponseType.ValidationFailed || e.type === ResponseType.Unknown) {
                console.warn(event.toRequest());
                this.errorService.log(new Error('Analytics queue error'));
            }
            this.persistQueue();
            this.setNotRunning();
        }).catch(e => {
            this.persistQueue();
            this.setNotRunning();
        });
    }

    async sendEvent(event: AnalyticsEvent): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(this.envService.getApiUrl() + TRACK_API_PATH, event.toRequest()).subscribe((data: any) => {
                resolve(data);
            }, error1 => {
                reject(error1);
            });
        });
    }

    async setNotRunning() {
        this._running = false;
        // this.backgroundMode.disable();
    }

    async getDebugData() {
        return new Promise(async (resolve, reject) => {
            const debugData: any = {};
            // debugData.queue = await this.storage.get(QUEUE_STORAGE);
            this.logs.enableLogsPersistance();
            debugData.logs = this.logs.logs;
            if (this.plt.is('android') || this.plt.is('ios')) {
                debugData.version = await this.envService.getVersion();
            }
            // debugData.user = await this.authenticationService.getUser();
            debugData.lastNotification = await this.storage.get('lastNotification');
            this.track('debug', debugData);
            resolve(debugData);
        });

    }

    private persistQueue() {
        // return this.storage.set(ANALYTICS_STORAGE, this.queue.toArray().map((item) => {
        //     return item.toRequest();
        // })).catch(err => {
        //     console.error('error persistQueue()', err);
        // });
    }


}
